import Loader from "./Loader.vue";

/**
 * Object of all the global components to be registered globally
 */
const globalComponents = {
  Loader,
};

export default globalComponents;
